module.exports = __webpack_public_path__ + "images/mdj/members/resume/quick_resume/icon_submit_arrow-0840aa5310f8571ce3472d6429d6a42c.png";